import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, ToastProvider, TooltipProvider } from '@buzzbee/ui';
import { App } from './App';
import { RouterProvider } from './lib/router';
import '@fontsource-variable/instrument-sans';
import '@fontsource-variable/jetbrains-mono';
import './index.css';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });

const el = document.getElementById('root');
if (!el) throw new Error('#root element missing');
createRoot(el).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider>
          <ToastProvider>
            <RouterProvider>
              <App />
            </RouterProvider>
          </ToastProvider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
